import React from "react";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <section className="section text-center">
      <div className="container">
        <h1 className="display-3 fw-bold text-navy mb-3">404</h1>
        <p className="text-secondary mb-4">Sorry, the page you're looking for doesn't exist.</p>
        <Link to="/" className="btn btn-brand px-4">Back to Home</Link>
      </div>
    </section>
  );
}

export default NotFound;
